export type OpenJobWorkspacePersonHandler = (
  profileId: string,
  label: string,
  evaluationId?: string | null,
) => void

export type JobWorkspacePersonOrigin = 'talent' | 'suggestions' | 'applicants' | 'analysis'

export type NavigateToJobWorkspacePersonOptions = {
  origin?: JobWorkspacePersonOrigin
  evaluationId?: string | null
  tab?: 'analysis' | 'profile'
}

export { buildJobWorkspacePersonPath } from '@yeshuman/sdk'

export function buildJobWorkspaceTalentListPath(jobId: string): string {
  return `/employer/jobs/${encodeURIComponent(jobId)}/talent`
}

/** @deprecated Use buildJobWorkspaceTalentListPath */
export function buildJobWorkspaceAnalysisListPath(jobId: string): string {
  return buildJobWorkspaceTalentListPath(jobId)
}

export function buildJobWorkspaceSuggestionsPath(jobId: string): string {
  return `/employer/jobs/${encodeURIComponent(jobId)}/suggestions`
}

export function buildJobWorkspaceApplicantsPath(jobId: string): string {
  return `/employer/jobs/${encodeURIComponent(jobId)}/applicants`
}

export function buildJobWorkspacePersonBackPath(
  jobId: string,
  origin: JobWorkspacePersonOrigin = 'talent',
): string {
  switch (origin) {
    case 'suggestions':
      return buildJobWorkspaceSuggestionsPath(jobId)
    case 'applicants':
      return buildJobWorkspaceApplicantsPath(jobId)
    case 'analysis':
    case 'talent':
    default:
      return buildJobWorkspaceTalentListPath(jobId)
  }
}

export type JobWorkspacePersonLocationState = {
  label?: string
  origin?: JobWorkspacePersonOrigin
  backPath?: string
}
